import { Box, Grid, InputAdornment, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

/** TRANSLATION*/
import { useTranslation } from 'react-i18next';


/** API */
import KeywordApi from 'api/setting/defaults/keyword.api';

/** UTILS || SLICE */
import { resetModal, submitModal, unSubmitModal } from 'app/slice/modal.slice';

import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils';
/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HeaderCard from 'component/CardCustom/HeaderCard';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import TableCustom from 'component/Table/TableCustom';
import TableRowCommon from 'component/Table/TableRowCommon';
import MainButton from 'new-components/buttons/main-button';
import SwitchButton from 'new-components/buttons/switch-button';
import SelectInput from 'new-components/inputs/select-input';
import TextAreaInput from 'new-components/inputs/text-area-input';
import TextInput from 'new-components/inputs/text-input';
import AlertModal from 'new-components/modal/alert-modal';
import PageModal from 'new-components/modal/page-modal';
import SnackbarComponent from 'new-components/snackbar/snackbar-component';

const initStateErrorMessage = {
  KEYWORD: ``,
  IS_DUPLICATE_WORD: ``,
  KEYWORD_STRING_BASE: ``,
  KEYWORD_STRING_EMPTY: ``,
  KEYWORD_MAXIMUM_LENGTH: ``,
  KEYWORD_ANY_REQUIRED: ``,

  CONTINUE_USED_REQUIRED: ``,
  USER_USED_REQUIRED: ``,
  KEYWORD_TYPE_REQUIRED: ``,
  MASSAGE_ANY_REQUIRED: ``,

  MASSAGE_STRING_BASE: '',
  MASSAGE_STRING_EMPTY: '',
  MASSAGE_MAXIMUM_LENGTH: ''
}

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

export default function Keyword() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [keywords, setKeywords] = useState([])
  const [keywordId, setKeywordId] = useState(Number)
  const [keywordType, setKeywordType] = useState('DISEASE')
  const [word, setMessage] = useState('')
  const [keywordStatus, setKeywordStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const [filterKeywordType, setFilterKeywordType] = useState<string>('ALL')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isPopup, setIsPopup] = useState(false)

  const keywordTypeSelect = [
    { value: 'DISEASE', label: t('KEYWORD.DISEASE') },
    { value: 'MEDICINE_USE', label: t('KEYWORD.MEDICINE_USE') },
    { value: 'BE_ALLERGIC', label: t('KEYWORD.BE_ALLERGIC') }
  ]

  const loadData = async () => {
    try {
      let condition: any = {}
      if (page) condition = { ...condition, page: page }
      if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
      if (search) condition = { ...condition, search: search }
      if (sortBy) condition = { ...condition, sortBy: sortBy }
      if (sortType) condition = { ...condition, sortType: sortType }
      if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }
      if (filterKeywordType) condition = { ...condition, keywordType: filterKeywordType === 'ALL' ? '' : filterKeywordType }

      const resp = await KeywordApi.findAll(condition)
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setKeywords(resp.data)
      } else {
        setKeywords([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    if (!keywordType || !word)
      return setErrorMessage({
        ...errorMessage,
        ...{
          KEYWORD_TYPE_REQUIRED: !keywordType ? t('กรุณาเลือกปรเภทคำ') : '',
          MASSAGE_ANY_REQUIRED: !word ? t('กรุณากรอกคำ') : ''
        }
      })

    const objCreate = {
      keywordType: keywordType,
      word: word,
      status: 'ACTIVE'
    }

    dispatch(submitModal())
    setDisabledSubmit(true)
    KeywordApi.create(objCreate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('KEYWORD.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()

          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`KEYWORD.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`KEYWORD.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const submitEdit = () => {
    if (!keywordType || !word)
      return setErrorMessage({
        ...errorMessage,
        ...{
          KEYWORD_TYPE_REQUIRED: !keywordType ? t('กรุณาเลือกปรเภทคำ') : '',
          MASSAGE_ANY_REQUIRED: !word ? t('กรุณากรอกคำ') : ''
        }
      })

    const objCreate = {
      keywordType: keywordType,
      word: word,
      status: keywordStatus
    }
    dispatch(submitModal())
    setDisabledSubmit(true)
    KeywordApi.update(keywordId, objCreate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`KEYWORD.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          if (err.message === 'IS_DUPLICATE_WORD') {
            setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`KEYWORD.MESSAGE.${err.message}`) } })
          } else setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`KEYWORD.MESSAGE.${err.message}`) } })

          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`KEYWORD.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setKeywordId(0)
    setKeywordType('DISEASE')
    setKeywordStatus('')
    setMessage('')
    setIsPopup(false)
    clearErrorMessage()
  }

  const onActive = () => {
    if (id) {
      KeywordApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('KEYWORD.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('KEYWORD.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      KeywordApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('KEYWORD.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('KEYWORD.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { keywordId, keywordType, word: keywordMessage, status: keywordStatus } = data
    setKeywordId(keywordId)
    setKeywordType(keywordType)
    setKeywordStatus(keywordStatus)
    setMessage(keywordMessage)
    setIsPopup(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }

  const handleChangeKeywordType = (valueKeywordType: string) => {
    setFilterKeywordType(valueKeywordType)
  }


  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'keywordType', disablePadding: false, label: t('KEYWORD.TABLE.CELL.TYPE'), align: 'left' },
    { id: 'word', disablePadding: false, label: t('KEYWORD.TABLE.CELL.KEYWORD') },
    { id: 'status', disablePadding: false, label: t('KEYWORD.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('KEYWORD.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { keywordId, keywordType, word: keywordMessage, updatedBy, updatedAt, status: keywordStatus } = objData
    const statusBtnActive = keywordStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = keywordStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: keywordId,
      id: keywordId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: t(`KEYWORD.${keywordType}`) },
        { option: 'TEXT', align: 'left', label: keywordMessage },
        { option: 'STATUS', align: 'center', label: keywordStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.word)
  }

  return (
    <Box >
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`KEYWORD.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`KEYWORD.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { word: name, status: t(`KEYWORD.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('KEYWORD.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('KEYWORD.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeKeywordType(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('KEYWORD.FILTER.MESSAGE_TYPE.ALL') },
                { value: 'DISEASE', name: t('KEYWORD.FILTER.MESSAGE_TYPE.DISEASE') },
                { value: 'MEDICINE_USE', name: t('KEYWORD.FILTER.MESSAGE_TYPE.MEDICINE_USE') },
                { value: 'BE_ALLERGIC', name: t('KEYWORD.FILTER.MESSAGE_TYPE.BE_ALLERGIC') },
              ]}
              label={t('KEYWORD.FILTER.MESSAGE_TYPE.LABEL')}
              value={filterKeywordType}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={6}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />

              <MainButton
                title={t('KEYWORD.BUTTON.ADD')}
                disabled={permissions.isCreate.disabled}
                type='primary'
                variant='contained'
                onClick={() => setIsPopup(true)}
                startIcon={<AddCircleIcon />}
              />
            </Box>
          </Grid>
        </Grid>
        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={keywords.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
        <PageModal
          title={keywordId ? t('KEYWORD.TITLE_UPDATE') : t('KEYWORD.TITLE_CREATE')}
          isOpen={isPopup}
          onCancel={{ onClick: () => resetForm() }}
          onSubmit={{ onClick: () => keywordId ? submitEdit() : submit(), disabled: disabledSubmit }}
          handleClose={resetForm}
          size={'XS'}
        >
          <Box py={2}>
            {keywordId ? (
              <Box display="flex" justifyContent="space-between" alignItems="center" pb={1}>
                <Typography>{t('KEYWORD.TITLE_STATUS')}</Typography>
                <SwitchButton
                  onChange={() => setKeywordStatus(keywordStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                  checked={keywordStatus === 'ACTIVE' ? true : false}
                />
              </Box>
            ) : (
              ''
            )}

            <Box display={'flex'} flexDirection={'column'} gap={'16px'}>
              <Box>
                <SelectInput
                  onChange={(event) => {
                    const value = event.target.value
                    if (value) {
                      setKeywordType(value)
                      clearErrorMessage()
                    }
                  }}
                  required={true}
                  label={t('KEYWORD.FILTER.MESSAGE_TYPE.LABEL')}
                  value={keywordType}
                  options={keywordTypeSelect.map((obj: any) => ({ ...obj, value: obj?.value, name: obj?.label }))}
                  helperText={errorMessage.KEYWORD_TYPE_REQUIRED}
                />
              </Box>
              <Box>
                <TextAreaInput
                  fullWidth
                  required={true}
                  label={t('KEYWORD.TABLE.CELL.KEYWORD')}
                  value={word}
                  helperText={errorMessage.IS_DUPLICATE_WORD || errorMessage.MASSAGE_STRING_BASE || errorMessage.MASSAGE_STRING_EMPTY || errorMessage.MASSAGE_MAXIMUM_LENGTH || errorMessage.MASSAGE_ANY_REQUIRED}
                  onChange={(e) => {
                    setMessage(e.target.value)
                    clearErrorMessage()
                  }}
                />
              </Box>
            </Box>
          </Box>
        </PageModal>
      </Box>
    </Box>
  )
}
